import type { Reference } from '@ps/web-martech-cms-types';
import type { SportsReference } from '@ps/web-sports-page-types';
import React from 'react';

import CMSReference from './CMSReference';

const CMSReferences: React.FC<{ references?: Reference[] | SportsReference[] }> = ({
  references
}) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {references?.map((ref) => (
      <CMSReference key={ref.uid} {...ref} />
    ))}
  </>
);

export default CMSReferences;
